export const FeatureKeys = {
  isExampleFlag: 'example-flag',
  bbogDiscoverExperiment: 'bb.og.discover',
  useExperimentApiRecommendations: 'use-experiment-api-recommendations',
  isPrReviewGroupsEnabled: 'pr-review-groups',
  sumCreateWorkspacePreChangeEnabled:
    'ADMINX-1261-workspaces-list-sum-pre-change',
  customMergeChecksActivated: 'custom-merge-checks-activated',
  postOfficeInAppSwitcher: 'post-office-in-bitbucket-switcher',
} as const;

export type FeatureKeyType = (typeof FeatureKeys)[keyof typeof FeatureKeys];

export const pipelinesStatsigKeys = {
  isPromotionFeatureDeprecated: 'bbc-pipelines-deprecate-promotion-feature',
  isPipelinesNativeEditorEnabled: 'bitbucket_pipelines_native_editor',
  isPipelinesStepFilterEnabled: 'enable_pipelines_step_filter',
  isPipelinesNavigationDropdownEnabled:
    'bitbucket_pipelines_navigation_dropdown_enabled',
  isPipelinePausedHaltedToStopEnabled:
    'bitbucket_pipelines_paused_halted_pipeline_to_stop',
  isPipelineListSidebarEnabled:
    'bitbucket-pipelines-pipeline-list-sidebar-enabled',
  isScheduleModalFilterLinkEnabled:
    'bitbucket_pipelines_schedule_filter_link_enabled',
  isPipelinesEnvironmentScreenEnabled: 'bitbucket_pipelines_environment_screen',
  isPipelinesMacOSTartRunnerEnabled: 'pipelines-mac-os-tart-runner',
  pipelinesArtifactPreviewSizeLimit: 'pipelines-artifact-preview-size-limit',
  pipelinesMaximumAllowedStepSizeForCloudRunners:
    'pipelines-max-allowed-step-size-for-cloud-runners',
  isExcludePathsChangesetConditionEnabled:
    'exclude_paths_changeset_condition_enabled',
  isSelfHostedRunnerWarningEnabled:
    'bitbucket_pipelines_self_hosted_runner_warning',
  isMergeQueuesEnabled: 'bbc-merge-queue-enabled',
  isMergeQueuesStrategyEnabled: 'bbc_merge_queues_strategy_enabled',
  isMergeQueuesLandingAreaEnabled: 'bbc_merge_queues_landing_area',
  isPipelinesRovoDevIntegrationEnabled:
    'bitbucket_pipelines_rovo_dev_integration',
  isBranchPrefixInMergeQueuesEnabled:
    'bbc_branch_prefix_in_merge_queues_enabled',
  isPassVariableInSchedulePipelineEnabled:
    'bitbucket_pipelines_variables_in_schedule_pipeline',
  isWorkspaceOverviewPipelinesTableEnabled:
    'bitbucket_pipelines_table_on_workspace_overview',
  isStepConcurrencyGroupStatusEnabled:
    'bitbucket_pipelines_step_concurrency_status',
  isFreePremiumRunnerBannerEnabled: 'pipelines_free-premium-runner-banner',
  isFreePremiumRunnerUiPostMigrationEnabled:
    'pipelines_free-premium-runner-ui-post-migration',
  isPipelinesTagSearchEnabled: 'bitbucket_pipelines_tag_search_support',
  isPipelineResultForgeModuleEnabled: 'bitbucket_pipeline_result_forge_module',
  isAgenticStepsEnabled: 'ai_agentic-step-enabled',
  isAgenticWorkspaceToggleEnabled:
    'bitbucket_pipelines_agentic_workspace_toggle',
  isPipelinesFinalStepEnabled: 'is-final-step-section-enabled',
  isStepStateConditionEnabled: 'bitbucket_pipelines_state_condition_enabled',
  isPipelinesTestManagementEnabled: 'pipelines-test-management',
  isNewCodeSearchEnabled: 'bbc-frontbucket-new-code-search',
  isTestsOpenBetaFeaturesEnabled:
    'bitbucket_pipelines_tests_open_beta_features',
  isTestsFixFlakyActionEnabled: 'bitbucket_tests_fix_flaky_action_enabled',
  isTestsRemoveActionEnabled: 'bitbucket_tests_remove_action',
  isTestsCreateJiraWorkItemEnabled: 'bitbucket_tests_create_jira_work_item',
  isTestsBulkActionsEnabled: 'bitbucket_tests_bulk_actions',
  pipelinesVariableLimitsConfig: 'result-service_pipeline-variable-limits',
  isParentChildArtifactSharingEnabled:
    'plan-service_parent-child-artifact-sharing',
  isTriggersV2Enabled: 'account-service_streamhub-trigger-event-enabled',
  isPipelinesFreeMinutesEnabled:
    'bitbucket_pipelines_free_minutes_banner_enabled',
  isNewPipelinesTroubleshooterEnabled:
    'bitbucket_pipelines_fix_failed_step_troubleshooter',
  isPipelinesRunnersPublicEndpointsEnabled:
    'bitbucket_pipelines_use_public_runner_endpoints',
  isPipelinesBuildStatusFaviconEnabled: 'bitbucket_pipelines_favicon',
  isChangeLogStreamingLogicEnabled:
    'bitbucket_pipelines_change_log_streaming_logic',
} as const;

export const StatsigFeatureKeys = {
  ...pipelinesStatsigKeys,
  copyableBranchName: 'bbc-copyable-branch-name',
  branchRestrictionsSettingsDisabled:
    'bbc-disable-branch-restrictions-settings',
  mergeStatusStateMessageDisabled: 'bbc-merge-status-state-message-disabled',
  postOfficeIntegrationInAppSwitcher:
    'post-office-integration-in-bitbucket-switcher',
  prCommentsSkipPrField: 'pr-comments-skip-pr-field',
  prCommitListV2: 'pr-commit-list-v2',
  bbcDefaultDeleteSourceBranchSetting:
    'bbc-default-delete-source-branch-setting',
  nextUnreviewedFile: 'bbc-frontbucket-next-unreviewed-file',
  markAllFiles: 'bbc-frontbucket-mark-all-files',
  supportGitAnnotateOnPRs: 'bbc-frontbucket-support-annotate-on-pr',
  descriptivePrUpdateFlag: 'descriptive_pr_update_flag',
  staleBranchesFilter: 'stale-branch-list-filter',
  bbcAtlaskitEditorCodeSyntaxHighlighting:
    'bbc-atlaskit-editor-code-syntax-highlighting',
  useAddCommentAsDefaultCommentAction:
    'bbc-afmhacks-add-comment-as-default-comment-action',
  codeReviewerCommentUuidConfig: 'frontbucket-autoreview-comment-uuid',
  repoMigrationFlag: 'fsx-repo-migration-flag',
  isRovoOnboardingUXEnabled: 'bbc-rovo-data-onboarding-ux',
  isChangeFileTreeFilteringEnabled:
    'bbc-frontbucket-enable-change-filetree-filtering',
  myPullRequestsButtonEnabled: 'bitbucket_my_pull_requests_button',
  codeSearchPortalLink: 'bbc-x-product-search-link-to-csp',
  bbcBetterImageDiff: 'bbc_better_image_diff',
  editorCaptionsEnabled: 'bbc-editor-captions-enabled',
  enhancedGasV3PREvents: 'enhanced-gasv3-pr-events',
  disableBranchFetchesByDefault: 'disable-branch-fetches-by-default',
  bbcPublicMergeConflictsApis: 'bbc-public-merge-conflicts-apis',
  autoreviewBlockedRepoSlugs: 'autodev-blocked-repos',
  afmDisableBranchPrefetching: 'bbc-afm-disable-branch-prefetching',
  useBbpBuildDataForBranchSelectors:
    'bbc-use-bbp-build-data-for-branch-selectors',
  codeReviewerStatusCard: 'code_reviewer_status_card',
  codeReviewerFrontendSettingsCacheTimeout:
    'code-reviewer-fe-settings-cache-timeout',
  prLiveReloadSourceBranchUpdates: 'bbc-pr-live-reload-source-branch-updates',
  deploymentsVisibilityUi: 'bbc-enable-deployments-visibility-ui',
  bbcEmojiReactionsForPRComments: 'bbc_emoji_reactions_for_pr_comments',
  prListIgnoreStoppedBuildStatus: 'pr_list_ignore_stopped_build_status',
  codeReviewerStatusCardPollingRate: 'code-reviewer-status-card-polling-rate',
  bbcDiffSearchChanges: 'bbc-diff-search-changes',
  showUnlinkedWsFlagUi: 'bbc-show-unlinked-ws-flag-ui',
  bbcRecentlyPushedBranchesBanner: 'bbc-recently-pushed-branches-banner',
  bbcUnlinkedWsModal: 'bbc-unlinked-ws-modal',
  bbcUnlinkedWsNotifications: 'bbc-unlinked-ws-notifications',
  codeReviewerManualTriggerEnabled: 'code_reviewer_manual_retrigger_enabled',
  bbcNonDismissibleUnlinkedWsFlag: 'bbc-non-dismissible-unlinked-ws-flag',
  unresolvedCommentsCheck: 'unresolved-comments-check',
  prCommentsImageResizingEnabled:
    'bitbucket_pr_comments_image_resizing_enabled',
  bbcPrLiveReloadM2: 'bbc-pr-live-reload-m2',
  bbcStarredObjects: 'bbc-starred-objects',
  bbcStarredObjectsSpotlight: 'bbc-starred-objects-spotlight',
  ipmChoreographer: 'bbc-ipm-choreographer',
  fetchAuthorsCallAbortEnabledFG:
    'ep-209-bbc-pull-requests-logic-to-fetch-authors',
  enableResolvableGlobalComments: 'global-unresolved-comments-check',
  bbcUnlinkedWsPageBlock: 'bbc-unlinked-ws-page-block',
  autoreviewRepositoryTriggerSettingsBbcEnabled:
    'autoreview_repository_trigger_settings_bbc_enabled',
  createPrEditorStickyToolbar:
    'bbc-frontbucket-create-pr-editor-sticky-toolbar',
  afmHideMergeConflictSection: 'bbc-hide-merge-conflicts-warning-panel',
  codeReviewerCommentTracking: 'code-reviewer-comment-tracking',
  bbcFixLinksInTasksPanel: 'bbc-fix-links-in-tasks-panel',
  autoMergeEnhancementsEnabled: 'bbc-auto-merge-enhancements-enabled',
  showRovoDevActiveBenefitsModal: 'rovo-dev-active-benefits-modal',
  rovoDevCodeReviewerSpotlightEnabled: 'rovo-dev-code-reviewer-spotlight',
  showRovoDevInactiveBenefitsModal: 'rovo-dev-inactive-benefits-modal',
  workspaceReadOnlyMode: 'workspace-readonly-mode',
  isRemoveFromQueueEnabled: 'bitbucket_remove_from_queue_enabled',
  bbcPassDraftQueuedAsStates: 'bbc-pass-draft-queued-as-states',
  noNewXWorkspaceForks: 'bbc_no_new_xworkspace_forks',
  showRovoDevActiveBenefitsModalAdminOnly:
    'rovo-dev-active-benefits-modal-admin-only',
  bbTracingCritical: 'bb-tracing-critical',
  compassEosDisableCrossSell: 'compass-eos-disable-cross-sell',
  bbcDefaultPrTasksFromConfig: 'default-pr-tasks-from-config',
  floatingRovoButtonUi: 'floating-rovo-button-ui',
  removeXflowPluginsFromBitbucket:
    'commit-25910_remove_xflow_plugins_from_bitbucket',
  bbcAgenticPrComments: 'bbc_agentic_pr_comments',
  prNotFoundErrorState: 'bbc-pr-not-found-error-state',
  isPRAssetLoaderEnabled: 'bbc-frontbucket-pr-asset-loader',
  afmBbcBetterTasks: 'afm_bbc_better_tasks',
  bbcNewDashboard: 'bbc_new_dashboard',
  bbcNewDashboardDefaultOptIn: 'bbc-new-dashboard-default-opt-in-enabled',
  disableBbJiraInstallation: 'disable-bb-jira-installation',
  monacoEditorRemeasureFonts: 'bbc-monaco-editor-remeasure-fonts',
  showSolveWithRovoCommentAction: 'solve_with_rovo_bitbucket_comment_action',
  codeReviewerDefaultBillingSettingEnabled:
    'code-reviewer-default-billing-site-setting',
  reportAbuseEnabled: 'bbc-report-abuse-enabled',
  useNewWorkspaceMountedOAuthAccessTokenEndpoint:
    'use-new-workspace-mounted-oauth-access-token',
  fixContentTypeForRlcFiles: 'bbc-fix-content-type-for-rlc-files',
} as const;

export type StatsigFeatureKeyType =
  (typeof StatsigFeatureKeys)[keyof typeof StatsigFeatureKeys];

export const StatsigExperimentsKeys = {
  noForksAfterWorkspaceCreatedDate: 'workspace-block-fork-creation-date',
} as const;

export type StatsigExperimentsKeyType =
  (typeof StatsigExperimentsKeys)[keyof typeof StatsigExperimentsKeys];
